import React from "react";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import "./style.css";

function BusinessCardMinimal() {
  return (
    <div className="bcm-page">
      <button
        className="bcm-print-btn no-print"
        onClick={() => window.print()}
      >
        Print / Save as PDF
      </button>

      <div className="bcm-card">
        <div className="bcm-corner bcm-corner-tl"></div>
        <div className="bcm-corner bcm-corner-br"></div>

        <div className="bcm-top">
          <img src="/img/logo.svg" alt="Lozrian" className="bcm-logo" />
          <span className="bcm-tagline">Trading &amp; Business Solutions</span>
        </div>

        <div className="bcm-rule"></div>

        <div className="bcm-center">
          <h1 className="bcm-name">Kateryna Shapoval</h1>
          <p className="bcm-title">Co-Founder &amp; Director</p>
          <div className="bcm-accent"></div>

          <div className="bcm-contact">
            <a href="tel:+380502484053" className="bcm-contact-item">
              <FaPhoneAlt />
              <span>+380 50 248 4053</span>
            </a>
            <span className="bcm-contact-sep">&bull;</span>
            <a href="mailto:ks@lozrian.com" className="bcm-contact-item">
              <FaEnvelope />
              <span>ks@lozrian.com</span>
            </a>
          </div>
        </div>

        <div className="bcm-bottom">
          <span className="bcm-badge-label">Specialized Supply</span>
          <span className="bcm-badge-dot"></span>
          <span className="bcm-badge-value">Global Marine Lubricants</span>
        </div>
      </div>
    </div>
  );
}

export default BusinessCardMinimal;
